import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import PickDetail from "@/pages/PickDetail";
import PickHistory from "@/pages/PickHistory";
import Videos from "@/pages/Videos";
import Results from "@/pages/Results";
import Sportsbooks from "@/pages/Sportsbooks";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Players from "@/pages/Players";
import PlayerDetail from "@/pages/PlayerDetail";
import PickTracker from "@/pages/PickTracker";
import Challenge from "@/pages/Challenge";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CommandCenter from "@/pages/CommandCenter";
import SEODashboard from "@/pages/SEODashboard";
import ThumbnailGenerator from "@/pages/ThumbnailGenerator";
import ThumbnailCreator from "@/pages/ThumbnailCreator";
import Subscription from "@/pages/Subscription";
import PaymentResult from "@/pages/PaymentResult";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Bracket from "@/pages/Bracket";
import SharedBracket from "@/pages/SharedBracket";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { BracketPromoModal, ExitIntentModal } from "@/components/BracketModals";
import { HelpWidget } from "@/components/HelpWidget";

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <div className="App dark">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pick/:id" element={<PickDetail />} />
            <Route path="/history" element={<PickHistory />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/tracker" element={<PickTracker />} />
            <Route path="/challenge" element={<Challenge />} />
            <Route path="/results" element={<Results />} />
            <Route path="/sportsbooks" element={<Sportsbooks />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/article/:slug" element={<ArticleDetail />} />
            <Route path="/players" element={<Players />} />
            <Route path="/players/:slug" element={<PlayerDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/command-center" element={<CommandCenter />} />
            <Route path="/admin/seo" element={<SEODashboard />} />
            <Route path="/thumbnail" element={<ThumbnailGenerator />} />
            <Route path="/thumbnail/create" element={<ThumbnailCreator />} />
            <Route path="/subscribe" element={<Subscription />} />
            <Route path="/payment/result" element={<PaymentResult />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            {/* Bracket routes hidden - tournament ended */}
            {/* <Route path="/bracket" element={<Bracket />} /> */}
            {/* <Route path="/bracket/view/:bracketId" element={<SharedBracket />} /> */}
          </Routes>
          {/* Bracket modals hidden - tournament ended */}
          {/* <BracketPromoModal /> */}
          {/* <ExitIntentModal /> */}
          <HelpWidget />
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;